import React from 'react'
import {
    FaAt,
    FaBars,
    FaBluetoothB,
    FaBus,
    FaCar,
    FaCheck,
    FaChevronDown,
    FaChevronLeft,
    FaChevronRight,
    FaChevronUp,
    FaDollarSign,
    FaDoorOpen,
    FaEye,
    FaFacebookF,
    FaFileDownload,
    FaFilePdf,
    FaFileSignature,
    FaFire,
    FaInfoCircle,
    FaInstagram,
    FaLinkedinIn,
    FaMapMarkerAlt,
    FaParking,
    FaRegCopy,
    FaRegCreditCard,
    FaRegListAlt,
    FaRegQuestionCircle,
    FaRegSquare,
    FaRulerCombined,
    FaShieldAlt,
    FaShoppingCart,
    FaSubway,
    FaTabletAlt,
    FaTimes,
    FaTrain,
    FaUser,
    FaUserFriends,
    FaVideo,
    FaWheelchair,
    FaYoutube,
    FaWhatsapp,
    FaLockOpen,
    FaLock,
    FaBuilding,
    FaDoorClosed,
    FaSearch,
    FaCamera,
    FaShare,
    FaEyeSlash,
    FaHome,
    FaArrowRight,
    FaStar,
    FaBolt,
    FaBarcode,
    FaClock,
    FaHeadphones
} from 'react-icons/fa'

import {
    MdOutline360,
    MdOpenInFull,
    MdOutlineCloseFullscreen,
    MdOutlineDoorFront,
    MdOutlineInventory2,
    MdOutlineHeadsetMic,
    MdOutlineCameraOutdoor,
    MdArchive,
    MdUnarchive
} from 'react-icons/md'
import { IconType } from 'react-icons'
import { LuMapPin } from 'react-icons/lu'
import { GiCardboardBox } from 'react-icons/gi'
import { PiWarningCircleFill } from 'react-icons/pi'
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5'
import { SlPresent } from 'react-icons/sl'
// @ts-ignore
import BoxBasic from 'src/business/ordering/assets/insurance/box-basic.svg'
// @ts-ignore
import BoxPlus from 'src/business/ordering/assets/insurance/box-plus.svg'
// @ts-ignore
import BoxPremium from 'src/business/ordering/assets/insurance/box-premium.svg'
// @ts-ignore
import SpeedCamera from 'src/business/ordering/assets/insurance/speed-camera.svg'
import {
    FiVideo,
    FiLock,
    FiClock,
    FiFileText,
    FiHeadphones
} from 'react-icons/fi'

const GoogleChatBubbleDots: IconType = props =>
    React.createElement(
        'svg',
        { viewBox: '0 0 20 20', fill: 'none', ...props },
        React.createElement('path', {
            d: 'M6 9C6.28333 9 6.52083 8.90417 6.7125 8.7125C6.90417 8.52083 7 8.28333 7 8C7 7.71667 6.90417 7.47917 6.7125 7.2875C6.52083 7.09583 6.28333 7 6 7C5.71667 7 5.47917 7.09583 5.2875 7.2875C5.09583 7.47917 5 7.71667 5 8C5 8.28333 5.09583 8.52083 5.2875 8.7125C5.47917 8.90417 5.71667 9 6 9ZM10 9C10.2833 9 10.5208 8.90417 10.7125 8.7125C10.9042 8.52083 11 8.28333 11 8C11 7.71667 10.9042 7.47917 10.7125 7.2875C10.5208 7.09583 10.2833 7 10 7C9.71667 7 9.47917 7.09583 9.2875 7.2875C9.09583 7.47917 9 7.71667 9 8C9 8.28333 9.09583 8.52083 9.2875 8.7125C9.47917 8.90417 9.71667 9 10 9ZM14 9C14.2833 9 14.5208 8.90417 14.7125 8.7125C14.9042 8.52083 15 8.28333 15 8C15 7.71667 14.9042 7.47917 14.7125 7.2875C14.5208 7.09583 14.2833 7 14 7C13.7167 7 13.4792 7.09583 13.2875 7.2875C13.0958 7.47917 13 7.71667 13 8C13 8.28333 13.0958 8.52083 13.2875 8.7125C13.4792 8.90417 13.7167 9 14 9ZM0 20V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H4L0 20ZM3.15 14H18V2H2V15.125L3.15 14Z',
            fill: 'currentColor'
        })
    )

const Google123Box: IconType = props =>
    React.createElement(
        'svg',
        { viewBox: '0 0 20 20', fill: 'none', ...props },
        React.createElement('path', {
            d: 'M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2ZM4.5 11H5.65V5H4.75L3 6.25L3.6 7.15L4.5 6.5V11ZM7.6 11H11.5V10H9.15L9.1 9.95C9.45 9.61667 9.7375 9.33333 9.9625 9.1C10.1875 8.86667 10.3667 8.68333 10.5 8.55C10.8 8.25 11.025 7.95 11.175 7.65C11.325 7.35 11.4 7.03333 11.4 6.7C11.4 6.21667 11.2167 5.8125 10.85 5.4875C10.4833 5.1625 10.0167 5 9.45 5C9.01667 5 8.625 5.125 8.275 5.375C7.925 5.625 7.68333 5.95 7.55 6.35L8.55 6.75C8.63333 6.53333 8.75417 6.3625 8.9125 6.2375C9.07083 6.1125 9.25 6.05 9.45 6.05C9.7 6.05 9.90417 6.11667 10.0625 6.25C10.2208 6.38333 10.3 6.55 10.3 6.75C10.3 6.93333 10.2667 7.10417 10.2 7.2625C10.1333 7.42083 9.98333 7.61667 9.75 7.85L8.95 8.65L7.6 10V11ZM15 11C15.6 11 16.0833 10.8333 16.45 10.5C16.8167 10.1667 17 9.73333 17 9.2C17 8.9 16.9167 8.63333 16.75 8.4C16.5833 8.16667 16.35 7.98333 16.05 7.85V7.8C16.2833 7.66667 16.4667 7.49583 16.6 7.2875C16.7333 7.07917 16.8 6.83333 16.8 6.55C16.8 6.1 16.625 5.72917 16.275 5.4375C15.925 5.14583 15.4833 5 14.95 5C14.5333 5 14.1458 5.12083 13.7875 5.3625C13.4292 5.60417 13.2 5.9 13.1 6.25L14.1 6.65C14.1667 6.45 14.275 6.29167 14.425 6.175C14.575 6.05833 14.75 6 14.95 6C15.1667 6 15.3458 6.0625 15.4875 6.1875C15.6292 6.3125 15.7 6.46667 15.7 6.65C15.7 6.88333 15.6167 7.06667 15.45 7.2C15.2833 7.33333 15.0667 7.4 14.8 7.4H14.35V8.4H14.85C15.1833 8.4 15.4417 8.46667 15.625 8.6C15.8083 8.73333 15.9 8.91667 15.9 9.15C15.9 9.36667 15.8083 9.55417 15.625 9.7125C15.4417 9.87083 15.2333 9.95 15 9.95C14.7167 9.95 14.5 9.8875 14.35 9.7625C14.2 9.6375 14.0667 9.41667 13.95 9.1L12.95 9.5C13.0667 9.98333 13.3042 10.3542 13.6625 10.6125C14.0208 10.8708 14.4667 11 15 11ZM2 14H18V2H2V14Z',
            fill: 'currentColor'
        })
    )

const GoogleBarcode: IconType = props =>
    React.createElement(
        'svg',
        { viewBox: '0 0 24 24', fill: 'none', ...props },
        React.createElement('path', {
            d: 'M1 19V5H3V19H1ZM4 19V5H6V19H4ZM7 19V5H8V19H7ZM10 19V5H12V19H10ZM13 19V5H16V19H13ZM17 19V5H18V19H17ZM20 19V5H23V19H20Z',
            fill: 'currentColor'
        })
    )

const GoogleBarcodeScanner: IconType = props =>
    React.createElement(
        'svg',
        { viewBox: '0 0 24 24', fill: 'none', ...props },
        React.createElement('path', {
            d: 'M1 21V16H3V19H6V21H1ZM18 21V19H21V16H23V21H18ZM4 18V6H6V18H4ZM7 18V6H8V18H7ZM10 18V6H12V18H10ZM13 18V6H16V18H13ZM17 18V6H18V18H17ZM19 18V6H20V18H19ZM1 8V3H6V5H3V8H1ZM21 8V5H18V3H23V8H21Z',
            fill: 'currentColor'
        })
    )

type OrderIconDefinition = {
    viewBox: string
    path: string
    preserveAspectRatio?: string
}

const createOrderIcon =
    (
        name: string,
        { viewBox, path, preserveAspectRatio = 'none' }: OrderIconDefinition
    ): IconType =>
    props =>
        React.createElement(
            'svg',
            {
                viewBox,
                preserveAspectRatio,
                'data-order-icon': name,
                'aria-hidden': true,
                focusable: false,
                ...props
            },
            React.createElement('path', {
                d: path,
                fill: 'currentColor'
            })
        )

const OrderArrowDown = createOrderIcon('arrowDown', {
    viewBox: '6 8.59 12 7.41',
    path: 'M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z'
})

const OrderInfo = createOrderIcon('info', {
    viewBox: '2 2 20 20',
    path: 'M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
})

const OrderInventory = createOrderIcon('inventory', {
    viewBox: '2 2 20 20',
    path: 'M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-1 18H5V9h14v11zm1-13H4V4h16v3z M9 12h6v2H9z'
})

const OrderPerson = createOrderIcon('person', {
    viewBox: '4 4 16 16',
    path: 'M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
})

const OrderPlace = createOrderIcon('place', {
    viewBox: '4 2 16 20',
    path: 'M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z'
})

const OrderReceipt = createOrderIcon('receipt', {
    viewBox: '3 2 18 20',
    path: 'M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM15 20H6c-.55 0-1-.45-1-1v-1h10v2zm4-1c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z M9 7h6v2H9zM16 7h2v2h-2zM9 10h6v2H9zM16 10h2v2h-2z'
})

const OrderSecurity = createOrderIcon('security', {
    viewBox: '3 1 18 22',
    path: 'M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z'
})

const OrderBoxBasic: IconType = props =>
    React.createElement('img', { ...props, src: BoxBasic, alt: '' })
const OrderBoxPlus: IconType = props =>
    React.createElement('img', { ...props, src: BoxPlus, alt: '' })
const OrderBoxPremium: IconType = props =>
    React.createElement('img', { ...props, src: BoxPremium, alt: '' })
const OrderSpeedCamera: IconType = props =>
    React.createElement('img', { ...props, src: SpeedCamera, alt: '' })

const OrderHelpOutline: IconType = props =>
    React.createElement(
        'svg',
        {
            viewBox: '0 0 16 16',
            preserveAspectRatio: 'xMidYMid meet',
            'data-order-icon': 'helpOutline',
            'aria-hidden': true,
            focusable: false,
            ...props
        },
        React.createElement('circle', {
            cx: 8,
            cy: 8,
            r: 7.2,
            fill: 'none',
            stroke: 'currentColor',
            strokeWidth: 1.6
        }),
        React.createElement('path', {
            d: 'M7.2 10.8h1.6v-1c0-.7.39-1 .88-1.38.67-.52 1.52-1.18 1.52-2.82 0-1.77-1.43-3.2-3.2-3.2S4.8 3.83 4.8 5.6h1.6C6.4 4.72 7.12 4 8 4s1.6.72 1.6 1.6c0 .81-.43 1.15-.94 1.56-.68.54-1.46 1.16-1.46 2.64v1zm0 1.2h1.6v1.6H7.2V12z',
            fill: 'currentColor'
        })
    )

export const icon = {
    Search: FaSearch,
    Ok: FaCheck,
    Person: FaUser,
    Pin: FaHome,
    Menu: FaBars,
    Close: FaTimes,
    Fire: FaFire,
    Bluetooth: FaBluetoothB,
    Car: FaCar,
    Bus: FaBus,
    Trolley: FaBus,
    Tram: FaTrain,
    Metro: FaSubway,
    LeftSimpleArrow: FaChevronLeft,
    RightSimpleArrow: FaChevronRight,
    UpSimpleArrow: FaChevronUp,
    DownSimpleArrow: FaChevronDown,
    Facebook: FaFacebookF,
    Instagram: FaInstagram,
    Youtube: FaYoutube,
    Linkedin: FaLinkedinIn,
    DoorOpen: FaDoorOpen,
    Video: FaVideo,
    WheelChair: FaWheelchair,
    Parking: FaParking,
    Tablet: FaTabletAlt,
    Question: FaRegQuestionCircle,
    Box: FaRegSquare,
    Rulers: FaRulerCombined,
    At: FaAt,
    List: FaRegListAlt,
    CreditCard: FaRegCreditCard,
    Shield: FaShieldAlt,
    Cart: FaShoppingCart,
    Contract: FaFileSignature,
    Dollar: FaDollarSign,
    PDF: FaFilePdf,
    Eye: FaEye,
    FileDownload: FaFileDownload,
    Copy: FaRegCopy,
    Users: FaUserFriends,
    Info: FaInfoCircle,
    WhatsApp: FaWhatsapp,
    LockOpen: FaLockOpen,
    Lock: FaLock,
    Building: FaBuilding,
    DoorClosed: FaDoorClosed,
    Camera: FaCamera,
    Share: FaShare,
    PlusimBox: GiCardboardBox,
    EyeSlash: FaEyeSlash,
    ChatBubble: IoChatbubbleEllipsesOutline,
    Star: FaStar,
    MapMarker: FaMapMarkerAlt,
    ArrowRight: FaArrowRight,
    Warning: PiWarningCircleFill,
    Virtual360: MdOutline360,
    Google123: Google123Box,
    GoogleBarcodeReader: GoogleBarcode,
    GoogleQrCodeScanner: GoogleBarcodeScanner,
    GoogleChatBubbleOutline: GoogleChatBubbleDots,
    GoogleDoorFront: MdOutlineDoorFront,
    GoogleInventory2: MdOutlineInventory2,
    OrderBoxBasic,
    OrderBoxPlus,
    OrderBoxPremium,
    GoogleArchive: MdArchive,
    GoogleUnarchive: MdUnarchive,
    Full: MdOpenInFull,
    PartFull: MdOutlineCloseFullscreen,
    Map: LuMapPin,
    Bolt: FaBolt,
    Gift: SlPresent,
    Barcode: FaBarcode,
    Clock: FaClock,
    Headphones: FaHeadphones,
    LineVideo: OrderSpeedCamera,
    LineLock: FiLock,
    LineClock: FiClock,
    LineFileText: FiFileText,
    LineHeadphones: MdOutlineHeadsetMic,
    OrderArrowDown,
    OrderHelpOutline,
    OrderInfo,
    OrderInventory,
    OrderPerson,
    OrderPlace,
    OrderReceipt,
    OrderSecurity
}
